import { combineReducers } from 'redux'
import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'
import { createRoutine } from 'redux-saga-routines'
import { connectRouter } from 'connected-react-router'
import { History } from 'history'

import settingsReducer from './settings.reducer'
import themesReducer from './themes.reducers'
import patientReducer from '../patient/patient.reducer'
import todoReducer from '../todo/todo.reducer'
import deviceReducer from '../device/device.reducer'
import authReducer from '../auth/index.reducer'
import loginReducer from '../auth/Login/index.reducer'
import forgotPassworReducer from '../auth/ForgotPassword/forgotPassword.reducer'
import acceptInviteReducer from '../auth/InviteUser/acceptInvite.reducer'
import signupReducer from '../auth/Signup/index.reducer'
import changePasswordReducer from '../auth/ChangePassword/index.reducer'
import usersReducer from '../users/index.reducer'
import practiceReducer from '../organizations/index.reducer'
import { IAuthState } from '../auth/index.interface'
import messageReducer from '../message/message.reducer'
import notesReducer from '../note/note.reducer'
import billingReducer from '../billing/billing.reducer'
import timeTrackingReducer from '../Timetracking/timeTracking.reducer'
import callLogsReducer from '../callLog/callLog.reducer'
import patientSettingReducer from '../setting/settings.reducer'
import patientVitalsReducer from '../vital/vital.reducer'
import timeTrackerReducer from '../patient/profile/TimeTracker/timetracker.reducer'
import { ITimeTrackerState } from '../patient/profile/TimeTracker/timetracker.interface'

const formReducer = require('redux-form').reducer

export const STARTUP = createRoutine('STARTUP')

const PERSIST_CONFIG = {
  key: 'login',
  storage,
  version: 1,
  whitelist: ['token', 'user', 'expiryTime', 'refreshToken', 'timerCount', 'patientId'],
}

const createRootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    form: formReducer,
    todos: todoReducer,
    device: deviceReducer,
    patient: patientReducer,
    settings: settingsReducer,
    theme: themesReducer,
    auth: persistReducer<IAuthState, any>(PERSIST_CONFIG, authReducer),
    forgotPassword: forgotPassworReducer,
    acceptInvite: acceptInviteReducer,
    signup: signupReducer,
    changePassword: changePasswordReducer,
    users: usersReducer,
    practices: practiceReducer,
    login: loginReducer,
    message: messageReducer,
    note: notesReducer,
    billing: billingReducer,
    timeTracking: timeTrackingReducer,
    callLogs: callLogsReducer,
    patientSetting: patientSettingReducer,
    vitals: patientVitalsReducer,
    timeTracker: persistReducer<ITimeTrackerState, any>(PERSIST_CONFIG, timeTrackerReducer),
  })

export default createRootReducer
